import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Category = iotsUtils.fromList(constants.report.tag.categories);

export const Id = iotsUtils.fromList(constants.report.tag.ids);
